export default __webpack_public_path__ + "static/media/SAS0110.34I-32482_-17829_0.fefd19d7.jpg";